module.exports = __webpack_public_path__ + "img/couponBg1.c39e9f50.png";